import type {
  MetricName,
  MetricTagName,
  MetricTags,
  MetricTagsByName,
} from 'src/internal/metrics/types';
import type {ObservabilityConfig} from 'src/types';

// Default/provider parameters are validated globally, then narrowed to the
// concrete metric tag shape at the call boundary.
type RedactedMetricTags = Partial<
  Record<MetricTagName, MetricTagsByName[MetricTagName] | '[REDACTED]'>
>;

export default function buildParams<T extends MetricName>(
  config: ObservabilityConfig,
  parameters?: MetricTagsByName,
): MetricTags<T> | undefined {
  const disable = config.metrics?._tmp_disableAllowList ?? true;
  const configAllowList = new Set(config.metrics?.parametersAllowList);
  const configParameters: MetricTagsByName = config.metrics?.parameters || {};
  const result: RedactedMetricTags = {};

  for (const key in configParameters) {
    if (configParameters.hasOwnProperty(key)) {
      const metricTagName = key as MetricTagName;
      result[metricTagName] =
        configAllowList.has(metricTagName) || disable
          ? configParameters[key as MetricTagName]
          : '[REDACTED]';
    }
  }

  for (const key in parameters) {
    if (parameters.hasOwnProperty(key)) {
      const metricTagName = key as MetricTagName;
      result[metricTagName] =
        configAllowList.has(metricTagName) || disable
          ? parameters[key as MetricTagName]
          : '[REDACTED]';
    }
  }

  if (Object.keys(result).length === 0) {
    return undefined;
  }

  return result as MetricTags<T>;
}
